import { Component, signal } from '@angular/core';
import { RefresherCustomEvent } from '@ionic/angular';
import { PushManagerProvider } from 'src/providers/push/push-manager.provider';
import { StatisticsProvider } from 'src/providers/statistics.provider';
import { TabsProvider } from 'src/providers/tabs/tabs.provider';
import { StatisticModel } from 'src/shared/models/user/statistic.model';

@Component({
  selector: 'rota-page-statistics',
  styleUrl: 'statistics.page.scss',
  templateUrl: 'statistics.page.html',
  standalone: false,
})
export class StatisticsPage {
  statistics = signal<StatisticModel[]>([]);

  isLoading = signal<boolean>(false);

  constructor(
    public tabsProvider: TabsProvider,
    public statisticsService: StatisticsProvider,
    public pushManagerProvider: PushManagerProvider
  ) {}

  async ionViewWillEnter() {
    await this.getStatisticForUser();
    await this.readStatistics();
  }

  async readStatistics() {
    const notReadStatistics = this.statistics()
      .filter((s) => !s.isRead)
      .map((s) => s.id);
    if (notReadStatistics.length) {
      await this.statisticsService.readBatchStatistics(notReadStatistics);
      await this.pushManagerProvider.fetchNotifications();
    }
  }

  async getStatisticForUser() {
    this.isLoading.set(true);
    const statistics = await this.statisticsService.getStatisticForUser();
    this.statistics.set(statistics.sort((a, b) => (a.order > b.order ? 1 : -1)));
    this.isLoading.set(false);
  }

  async handleRefresh(event: RefresherCustomEvent) {
    await this.getStatisticForUser();
    event.target.complete();
  }

  async goBack() {
    await this.tabsProvider.forwardBack();
  }
}
